var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarNewEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 97c-5,1 -8,3 -10,6 -3,3 -4,9 -4,14 1,12 14,21 23,27 75,52 57,55 114,14 13,-9 30,-18 38,-30 5,-7 8,-18 2,-25 -6,-7 -11,-6 -20,-6 -42,0 -84,0 -126,0 -5,0 -12,0 -17,0zm108 141l-32 0 -73 0c-9,0 -15,-5 -16,-12 -1,-3 -1,-10 -1,-14l0 -69c14,13 76,57 90,57 14,0 76,-44 90,-57l0 38 -20 0c-4,0 -7,3 -7,6l0 25 -25 0c-3,0 -6,3 -6,7l0 19zm102 -7l0 14c0,4 -2,7 -6,7l-25 0 0 25c0,3 -3,6 -6,6l-15 0c-3,0 -6,-3 -6,-6l0 -25 -25 0c-4,0 -7,-3 -7,-7l0 -14c0,-3 3,-6 7,-6l25 0 0 -25c0,-4 3,-7 6,-7l15 0c3,0 6,3 6,7l0 25 25 0c4,0 6,3 6,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarNewEmail);
export default __webpack_public_path__ + "static/media/toolbar-new_email.412bbf73.svg";
export { ForwardRef as ReactComponent };